// Copyright 2023 Sorama B.V.
import { DialogController } from "aurelia-dialog";
import { autoinject } from "aurelia-framework";

export interface ConfirmationModel {
    title?: string;
    text?: string;
    itemList?: string[];
    confirmText?: string;
    cancelText?: string;
    operation?: () => Promise<unknown>;
}

@autoinject
export class ConfirmationDialog {
    // The default model
    private model: ConfirmationModel = {
        title: "Perform operation",
        text: "Are you sure you want to perform this operation?",
        confirmText: "Confirm",
        cancelText: "Cancel",
        operation: () => Promise.resolve(),
    };

    constructor(private readonly controller: DialogController) {}

    public activate(confirmationModel: ConfirmationModel) {
        // Overwrite the default properties if the property exists in the passed confirmationModel
        this.model = { ...this.model, ...confirmationModel };
    }

    protected cancel(): void {
        this.controller.cancel();
    }

    protected async confirm(): Promise<void> {
        try {
            const result = await this.model.operation();
            this.controller.ok(result);
        } catch (e) {
            // controller.error(e.message) does not work properly for some reason
            this.controller.close(false, e.message);
        }
    }
}
